<template>
  <div>
    <h1>Наши Работы</h1>
    <gallery :images="images" :index="index" @close="index = null"></gallery>
    <div
      class="image"
      v-for="(image, imageIndex) in images"
      :key="imageIndex"
      @click="index = imageIndex"
      :style="{
        backgroundImage: 'url(' + image + ')',
        width: '250px',
        height: '200px',
      }"
    ></div>
  </div>
</template>

<script>
import VueGallery from "vue-gallery";

export default {
  name: "catalog",
  data: function () {
    return {
      images: [
        "/assets/imgs_catalog/1.jpg",
        "/assets/imgs_catalog/3.jpg",
        "/assets/imgs_catalog/4.jpg",
        "/assets/imgs_catalog/5.jpg",
        "/assets/imgs_catalog/6.jpg",
        "/assets/imgs_catalog/7.jpg",
        "/assets/imgs_catalog/8.jpg",
        "/assets/imgs_catalog/9.jpg",
        "/assets/imgs_catalog/10.jpg",
        "/assets/imgs_catalog/11.jpg",
        "/assets/imgs_catalog/12.jpg",
        "/assets/imgs_catalog/13.jpg",
        "/assets/imgs_catalog/14.jpg",
        "/assets/imgs_catalog/15.jpg",
        "/assets/imgs_catalog/16.jpg",
        "/assets/imgs_catalog/17.jpg",
        "/assets/imgs_catalog/18.jpg",
        "/assets/imgs_catalog/19.jpg",
        "/assets/imgs_catalog/20.jpg",
        "/assets/imgs_catalog/21.jpg",
        "/assets/imgs_catalog/22.jpg",
        "/assets/imgs_catalog/23.jpg",
        "/assets/imgs_catalog/24.jpg",
        "/assets/imgs_catalog/25.jpg",
        "/assets/imgs_catalog/26.jpg",
        "/assets/imgs_catalog/27.jpg",
        "/assets/imgs_catalog/28.jpg",
        "/assets/imgs_catalog/29.jpg",
        "/assets/imgs_catalog/30.jpg",
        "/assets/imgs_catalog/31.jpg",
        "/assets/imgs_catalog/32.jpg",
        "/assets/imgs_catalog/33.jpg",
        "/assets/imgs_catalog/34.jpg",
        "/assets/imgs_catalog/35.jpg",
        "/assets/imgs_catalog/36.jpg",
        "/assets/imgs_catalog/37.jpg",
        "/assets/imgs_catalog/38.jpg",
        "/assets/imgs_catalog/39.jpg",
        "/assets/imgs_catalog/40.jpg",
        "/assets/imgs_catalog/41.jpg",
        "/assets/imgs_catalog/42.jpg",
        "/assets/imgs_catalog/43.jpg",
        "/assets/imgs_catalog/44.jpg",
        "/assets/imgs_catalog/45.jpg",
        "/assets/imgs_catalog/46.jpg",
        "/assets/imgs_catalog/47.jpg",
        "/assets/imgs_catalog/48.jpg",
        "/assets/imgs_catalog/49.jpg",
        "/assets/imgs_catalog/50.jpg",
        "/assets/imgs_catalog/51.jpg",
        "/assets/imgs_catalog/52.jpg",
        "/assets/imgs_catalog/53.jpg",
      ],
      index: null,
    };
  },

  components: {
    gallery: VueGallery,
  },
};
</script>

<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 3px;
  margin-left: 70px;
  margin-bottom: 15px;
}

/* div{
    margin-top: 70px;
  } */
h1 {
  margin-top: 100px;
  margin-bottom: 50px;
}
</style>
